import { render } from "./PeopleList.vue?vue&type=template&id=5d165d30&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"

import "./PeopleList.vue?vue&type=style&index=0&id=5d165d30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d165d30"]])

export default __exports__